import { Api, getApiHost } from '../../../utils/index.js';
export const getUtmValuesFromUrl = () => {
    let utmValues = null;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach((val, key) => {
        if (key.startsWith('utm')) {
            if (utmValues === null) {
                utmValues = {};
            }
            const obj = {};
            obj[key] = val;
            utmValues = Object.assign(utmValues, obj);
        }
    });
    return utmValues;
};
export const sendTelemetry = (telemetryEvent) => {
    const req = new XMLHttpRequest();
    const url = `${getApiHost()}${Api.CAL_TELEMETRY}/events`;
    req.open('POST', url, true);
    req.setRequestHeader('Content-Type', 'application/json');
    req.send(JSON.stringify(telemetryEvent));
};
